import React, { useState, useEffect, useRef, useContext } from "react";
import "../../styles/casedetails.css";
import "../../styles/payment.css";
import BackLoader from "../../components/backloader";
import * as Constants from "../../constants";
import DynamicIcon from "../dynamicicon";
import JisButton from "../controls/jisButton";
import JisCheckbox from "../controls/jisCheckbox";
import { Link, useNavigate, useParams } from "react-router-dom";
import JisDialog from "../dialog";
import JisYesNo from "../controls/jisYesNo";
import { ShareContext } from "../../context/ShareContext";

export default function Payment({ feeid }) {
  //switch happen here
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [parties, setParties] = useState([]);
  const [cinfo, setCaseInfo] = useState(null);
  const [fee, setFee] = useState(null);
  const [feelines, setFeelines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [partyId, setPartyId] = useState(0);
  const [partyOptions, setPartyOptions] = useState([]);
  const [fiat, setFiat] = useState(null);
  const [isParty, setIsParty] = useState(true);
  const [payNow, setPayNow] = useState(true);
  const [webguid, setWebguid] = useState("");
  const [alreadyPaid, setAlreadyPaid] = useState(false);
  const [gotodetails, setGotoDetails] = useState(true);

  const [gateway, setGateway] = useState(null);
  const billRef = useRef(null);
  const formRef = useRef();

  useEffect(() => {
    onLoadGateway();
    if (token != null) {
      onLoad();
    }
  }, [token]);

  const onLoad = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/payments/fee/${feeid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setFee(data.fee);
        setFeelines(data.feelines);
        setCaseInfo(data.cinfo);
        setParties(data.parties);
        setFiat(data.fiat);
        setPartyId(data.parties[0]?.id);
      } else if (data.code == 1) {
        setFee(data.fee);
        setAlreadyPaid(true);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadGateway = async () => {
    //for account registration
    const url = `${Constants.apiUrl}/payment/current-gateway`;
    console.log(`the calling url to check cnahes ${url}`);
    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();

      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setGateway(data.current);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const ProcessPay = async () => {
    setLoading(true);

    try {
      var _partyid = partyId;
      if (partyId == "") {
        _partyid = data.parties[0]?.id;
      }
      var payinfo = { partyId: _partyid };
      const resp = await fetch(
        `${Constants.apiUrl}/filing/payment-process/${feeid}`,
        {
          method: "POST",
          body: JSON.stringify(payinfo),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        console.log("Webguid... " + data.webGuid);
        setWebguid(data.webGuid);
        localStorage.setItem("activefeeid", feeid);
        var bill = `JISE${feeid}`;
        billRef.current = bill;
        console.log('gateway below')
        console.log(gateway);
        console.log(`the bill reference ${billRef.current}`);
        if (gateway?.name == "Pay4it") {
          window.location = `https://usepay4it.com/payment/collection/mda?mda=${Constants.pay4it_key}&callbackUrl=${Constants.payment_callback}&internalBillReference=${bill}`;
        } else if (gateway?.name == "Paystack") {
          if (formRef.current) {
            formRef.current.requestSubmit(); // preferred over formRef.current.submit()
          }
        }else if (gateway?.name == "e-Transact") {
          console.log('it enter to go with '+data.callingurl)
          window.location = data.callingurl;
        }
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onPayLater = () => {
    navigate("/my-cases"); //redirect to your cases
  };
  const onAlreadyPayment = () => {
    if (gotodetails) navigate(`/document-upload/${fee.id}`);
    else {
      navigate("/my-cases");
    }
  };

  return (
    <div className="payment">
      <div className="main">
        {/* <div className="section-header">Payment</div> */}

        {/* <div className="suit-number-section">
                      <div>Suit Number</div>
                      <div>{cinfo?.caseNumber==null?cinfo?.referenceNumber:cinfo?.caseNumber}</div>
                    </div> */}

        <div className="amount">
          <p>Total Amount (N)</p>
          <p>₦ {Constants.formatCurrency(fee?.fee)}</p>
        </div>

        <div className="containers">
          {/* {isParty && (
            <div>
              <div className="select-group">
                <label>Please select any one of the party </label>
                <select
                  name="partyId"
                  value={partyId}
                  required
                  onChange={(e) => setPartyId(e.target.value)}
                >
                  <option value="">Please select any one of the party </option>
                  {parties.map((opt, index) => (
                    <option key={index} value={opt.id}>
                      {opt.firstName} {opt.lastName ?? ""}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )} */}
          {/* <div>
            {" "}
            <div
              onClick={() => setShow(!show)}
              style={{ cursor: "pointer", textAlign: "center" }}
            >
              {" "}
              <DynamicIcon
                iname={`${show ? "visibility" : "visibility_off"}`}
              />{" "}
              {show ? "Hide breakdown" : "Show break down"}
            </div>
            {show && (
              <div>
                <h4>See the Items</h4>
                <div className="table">
                  <div class="section-cases">
                    <span>Gazette Items Selected</span>
                  </div>
                  <table class="case-table">
                    <thead>
                      <tr>
                        <th className="col-id">S/N</th>
                        <th className="col-title"> Title</th>
                        <th>Amount</th>
                        <th className="col-id">Quantity</th>
                        <th>Total</th>
                        <th>Required</th>
                      </tr>
                    </thead>
                    <tbody>
                      {feelines?.map((line, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{line.title}</td>
                          <td>{line.perItem}</td>
                          <td>{line.qty}</td>
                          <td>{line.fee}</td>
                          <td>{line.isUpload ? "Document Expected" : ""}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div> */}

          <div>
            <div className="table">
              <div class="table-header">
                <p>Payment Breakdown</p>
              </div>
              <div className="table-wrapper">
                <table class="case-details-table">
                  <thead>
                    <tr>
                      <th className="col-id">S/N</th>
                      <th colSpan={2}> Description</th>
                      <th>Amount</th>
                      <th className="col-id">Quantity</th>
                      <th>Total</th>
                      {/* <th>Required</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {feelines?.map((line, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td colSpan={2}>{line.title || "N/A"}</td>
                        <td>{line.perItem || "N/A"}</td>
                        <td>{line.qty || "N/A"}</td>
                        <td>{line.perItem * line.qty || "N/A"}</td>
                        {/* <td>{line.isUpload ? "Document Expected" : ""}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* <div className="radio-row radio-row-container">
            <div className="radio-label">Payment By</div>
            <div className="radio-options">
              <JisCheckbox
                label="Party"
                value={isParty}
                onChange={(e) => setIsParty(true)}
              />
              <JisCheckbox
                label="Legal Counsel"
                value={!isParty}
                onChange={(e) => setIsParty(false)}
              />
            </div>
          </div> */}

          <div className="radio-row radio-row-container">
            <div className="radio-label">How would you like to pay?</div>
            <div className="radio-options">
              {/* <JisCheckbox
                label="Pay Now"
                value={payNow}
                onChange={(e) => setPayNow(true)}
              />
              <JisCheckbox
                label="Pay Later"
                value={!payNow}
                onChange={(e) => setPayNow(false)}
              /> */}

              {/* <JisButton type="button" onClick={ProcessPay}>
                Pay Now
              </JisButton> */}
              {/* <JisButton type="button" onClick={onPayLater}>
                Pay Later
              </JisButton> */}
              <button
                type="button"
                className="pay-now-btn"
                onClick={ProcessPay}
              >
                Pay Now
              </button>
              <button
                className="pay-later-btn"
                type="button"
                onClick={onPayLater}
              >
                Pay Later
              </button>
            </div>
          </div>

          <div className="button-container">
            {gateway?.name == "Paystack" && (
              <form ref={formRef} className="form-inp" action="/paystack.html">
                <input type="hidden" name="name" value={profile.firstName} />
                <input
                  type="hidden"
                  name="email"
                  value={profile.primaryEmail}
                />
                <input
                  type="hidden"
                  name="phone"
                  value={profile.primaryContactNumber}
                />
                <input
                  type="hidden"
                  name="returnurl"
                  value={`${Constants.payment_callback}/`}
                />
                <input type="hidden" name="amount" value={fee?.fee} />
                <input type="hidden" name="docref" value={`JISE${feeid}`} />
              </form>
            )}
            {/* {payNow ? (
              <JisButton type="button" onClick={ProcessPay}>
                Pay Now
              </JisButton>
            ) : (
              <JisButton type="button" onClick={onPayLater}>
                Pay Later
              </JisButton>
            )} */}
            {fiat && (
              <div className="flowerror" style={{ marginTop: 16 }}>
                The FIAT document you uploaded to this case is awaiting
                approval.
                {fiat.isApproved == null && (
                  <span style={{ fontWeight: "900" }}>
                    You can wait for approval without pay OR proceed
                    to make payment
                  </span>
                )}
                {fiat.isApproved == true && (
                  <span style={{ fontWeight: "900" }}>
                    {" "}
                    The FIAT is Approved.
                  </span>
                )}
                {fiat.isApproved == false && (
                  <span style={{ fontWeight: "900" }}>
                    {" "}
                    The FIAT is Rejected.
                  </span>
                )}
              </div>
            )}
          </div>
          <hr className="button-separator" />
        </div>
      </div>
      <BackLoader open={loading} />
      {alreadyPaid && (
        <JisDialog title="Payment already made">
          <div>
            Please note the payment is already sorted. Kindly goto Case details
            or goto Pending Upload to upload document
          </div>
          <div>
            {/*  <JisYesNo label="Yes means you want to go to associated case details, No means you want to return to list of cases"
                             value={gotodetails} onChange={(e)=>setGotoDetails(e)} /> */}
            <JisButton onClick={onAlreadyPayment}>Continue</JisButton>
          </div>
        </JisDialog>
      )}
    </div>
  );
}
